import { Badge, Spin } from 'antd';
import moment from 'moment';
import React, { useLayoutEffect, useMemo, useState } from 'react';
import { CSVLink } from 'react-csv';
import { FiFilter } from 'react-icons/fi';
import { GrDocumentCsv } from 'react-icons/gr';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import NoInvestment from '../../../assets/images/no_investment.svg';
import { HEADERMENU_PATH } from '../../../routes/RoutesURL';
import { RootState } from '../../../store/rootReducer';
import HSButton from '../../common/Button';
import CessationCard from '../../common/CessationCard';
import Loader from '../../common/Loader';
import TabsComponent from '../../common/Tabs';
import { commaSeperator, getUserFullName } from '../../utils/validation';
import ContactUsNew from '../dealList/components/ContactUsNew';
import DealsGridView from '../dealList/components/deals/GridView';
import { common_container } from '../dealList/components/deals/TopCard';
import DealActions from '../deals/redux/actions';
import { Deals } from '../deals/redux/types';
import UserAlret from '../userAlret';
import InvestmentMobileCard from './components/InvestmentMobileCard';
import InvestmentTable from './components/InvestmentTable';
import InvestmentPDFCreater from './components/PDFCreater';
import Outstanding from './components/TopCard/Outstanding';
import TotalInvested from './components/TopCard/TotalInvested';
import InvestmentUpdatedDocuments from './components/UpdatedDocuments';
import InvestmentFilterModal, { FilterOptions } from './modal/FilterModal';
import InvestmentsActions from './redux/actions';
import { filterRows } from './utils';

const Investments: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const loading = useSelector((state: RootState) => state.investments.loading);
    const investments = useSelector((state: RootState) => state.investments.investments);
    const filterData = useSelector((state: RootState) => state.investments.filterData);
    const userProfile = useSelector((state: RootState) => state.user.user?.userProfile);
    const deals: Deals[] = useSelector((state: RootState) => state.deal.deals);
    //const dealsLoading = useSelector((state: RootState) => state.deal.loading);
    // const aLoading = useSelector((state: RootState) => state.investments.aLoading);
    const outstanding = useSelector((state: RootState) => state.investments.aggregate?.outstanding);
    const invested = useSelector((state: RootState) => state.investments.aggregate?.invested);

    const [applyFilters, setApplyFilters] = useState<FilterOptions[]>([]);
    const [preFilterData, setPreFilterData] = useState<FilterOptions[]>([]);
    const [openFilter, setFilter] = useState(false);
    const [activeTab, setTab] = useState('outStanding_investment');

    const userName = getUserFullName(userProfile);

    useLayoutEffect(() => {
        dispatch(InvestmentsActions.getInvestmentsReq());
        dispatch(InvestmentsActions.fetchAggregate());
        dispatch(InvestmentsActions.fetchUpdatedDocuments());
        dispatch(InvestmentsActions.fetchInvestmentExecutedAgreements());
        dispatch(DealActions.getDeals());
    }, [dispatch]);

    const selectedCount = useMemo(() => {
        let count = 0;
        applyFilters.map((f) => {
            if (f.value && f.value.length > 0) {
                count = count + 1;
            }
            if (
                f.minValue !== undefined ||
                f.maxValue !== undefined ||
                f.toDate !== undefined ||
                f.fromDate !== undefined
            ) {
                count = count + 1;
            }
            return f;
        });

        return count;
    }, [applyFilters]);

    const applyFilter = (filter: FilterOptions[], filterData: FilterOptions[]) => {
        setApplyFilters(filter);
        setPreFilterData(filterData);
    };
    const upcomingDeals = useMemo(() => {
        const data = deals.filter((item) => item.deal.status.toLowerCase() === 'upcoming')[0];
        return data ? [data] : [];
    }, [deals]);

    const bannerDeals = useMemo(() => {
        const data: any =
            activeTab === 'outStanding_investment'
                ? outstanding?.deal
                : activeTab === 'total_invested'
                ? invested?.deal
                : null;

        if (!data) return null;

        const { totalOutstanding, totalDebtInvested } = data || {};
        const dealInfo = totalOutstanding || totalDebtInvested;

        if (dealInfo) {
            const { amountUpto2dp: amount, currency } = dealInfo;
            const title = totalOutstanding ? 'Outstanding Investment' : 'Total Investment';
            return { amount, currency, title };
        }

        return null;
    }, [outstanding, invested, activeTab]);

    if (loading) {
        return (
            <div className={`mb-4 ${common_container}`}>
                <div className="flex justify-center items-center py-6">
                    <Spin />
                </div>
            </div>
        );
    }
    if (!loading && investments.length === 0) {
        return (
            <div className={`mb-4 ${common_container}`}>
                <div className="flex justify-center items-center flex-col py-6">
                    <img src={NoInvestment} alt="NoInvestment" />
                    <p className="WorkSans font-semibold pt-5 text-xl md:text-2xl text-[#182D4F]">
                        You have no investments to date.
                    </p>
                    <p className="text-[#828282] font-[Lato] font-medium text-sm md:text-base mb-4">
                        Please check out our live deals.
                    </p>

                    <HSButton title="LIVE DEALS" type="primary" onClick={() => navigate(HEADERMENU_PATH.deals)} />
                </div>
            </div>
        );
    }
    return (
        <>
            <div>
                {openFilter && (
                    <InvestmentFilterModal
                        open={openFilter}
                        setOpen={setFilter}
                        filtersValues={filterData}
                        applyFilter={applyFilter}
                        preFilterData={preFilterData}
                    />
                )}
                <div className={`flex gap-2 pb-4 justify-between flex-col bg-[#f1f7ff] ${common_container}`}>
                    <div className="flex justify-between items-center gap-6 md:flex-row flex-col my-4 ">
                        <div className="w-full md:w-[65%] flex justify-between items-start">
                            <div>
                                <p className="text-[#142C53] font-[WorkSans-Semibold] text-2xl">
                                    Hi, {userName || ''}! Welcome back.
                                </p>
                                <span className="text-[#27AE60] text-sm font-[WorkSans]">
                                    Your personal dashboard overview
                                </span>
                            </div>
                        </div>

                        <div className="w-full md:w-[35%]">
                            <UserAlret text_div_className="block" align={'justify-start'} isDealAllow={true} />
                        </div>
                    </div>
                    <div className="flex gap-6 justify-between md:flex-row flex-col w-full">
                        <div className="md:w-[65%] w-full">
                            <div className="flex justify-between items-center gap-6 flex-col h-full">
                                <TabsComponent
                                    tabs={[
                                        { title: 'OUTSTANDING INVESTMENT', key: 'outStanding_investment' },
                                        { title: 'TOTAL INVESTED', key: 'total_invested' },
                                    ]}
                                    activeTab={activeTab}
                                    setActiveTab={setTab}
                                    inactiveClass="bg-white text-[#8AA8D8] cursor-pointer"
                                />
                                {activeTab === 'outStanding_investment' ? (
                                    <Outstanding />
                                ) : activeTab === 'total_invested' ? (
                                    <TotalInvested />
                                ) : null}
                                {loading && (
                                    <div className="flex justify-center items-center py-4">
                                        <Spin />
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="md:w-[35%] w-full flex flex-col gap-6">
                            {bannerDeals && (
                                <div className={`bg-white p-2 gap-2 w-full  flex flex-col justify-center`}>
                                    <div className="flex justify-between gap-1 items-center">
                                        <p className="text-[#142C53] WorkSans-Semibold font-semibold text-2xl">
                                            {commaSeperator(String(bannerDeals?.amount || 0))}
                                        </p>
                                        <InvestmentPDFCreater />
                                    </div>

                                    <div className="h-[1px] w-full bg-[#27AE60]" />
                                    <p className="WorkSans text-xs text-[#152C52]">
                                        {bannerDeals?.title}
                                        <span className="text-[#182D4F80] text-[10px]">
                                            &nbsp; ({bannerDeals?.currency})
                                        </span>
                                    </p>
                                </div>
                            )}
                            {upcomingDeals.length > 0 && <DealsGridView list={upcomingDeals} isInvestment={true} />}{' '}
                            <ContactUsNew isMobile isShowTitle={false} />
                        </div>
                    </div>
                </div>
            </div>
            {/* investment table */}
            <div className={`bg-[white] w-full py-4 ${common_container}`}>
                <div>
                    <div className="flex justify-between items-center mt-2 mb-6">
                        <p className="w-full text-[#152C52] text-left WorkSans-Semibold font-semibold text-xl md:text-3xl">
                            Investments
                        </p>
                        <CSVLink
                            data={investments.map((iv) => {
                                return {
                                    issuerName: iv.issuerName,
                                    dealName: iv.dealName,
                                    dealType: iv.dealType,
                                    instrumentType: iv.instrumentType,
                                    investmentAmount: iv.investmentAmount?.currency
                                        ? `${iv.investmentAmount.currency} ${commaSeperator(
                                              parseFloat(String(iv.investmentAmount.amountUpto2dp || 0)).toFixed(2),
                                          )}`
                                        : '0.00',
                                    investmentDate: iv.investmentDate
                                        ? moment(iv.investmentDate).format('DD-MMM-YYYY')
                                        : '',
                                    maturityDate: iv.maturityDate ? moment(iv.maturityDate).format('DD-MMM-YYYY') : '',
                                    interestRate: iv.interestRate ? `${iv.interestRate}%` : '',
                                    status: iv.status,
                                    totalDistribution: iv.totalDistribution
                                        ? `${iv.totalDistribution.currency} ${commaSeperator(
                                              parseFloat(String(iv.totalDistribution.amountUpto2dp || 0)).toFixed(2),
                                          )}`
                                        : '0.00',
                                    outstandingPrincipal: iv.outstandingPrincipal
                                        ? `${iv.outstandingPrincipal.currency} ${commaSeperator(
                                              parseFloat(String(iv.outstandingPrincipal.amountUpto2dp || 0)).toFixed(2),
                                          )}`
                                        : '0.00',
                                };
                            })}
                            headers={[
                                { key: 'issuerName', label: 'Issuer' },
                                { key: 'dealName', label: 'Deal' },
                                { key: 'dealType', label: 'Deal Type' },
                                { key: 'instrumentType', label: 'Instrument Type' },
                                { key: 'investmentAmount', label: 'Investment Amount' },
                                { key: 'investmentDate', label: 'Investment Date' },
                                { key: 'maturityDate', label: 'Maturity Date' },
                                { key: 'outstandingPrincipal', label: 'Outstanding Principal' },
                                { key: 'interestRate', label: 'Interest Rate' },
                                {
                                    key: 'totalDistribution',
                                    label: 'Total Distribution/Interest paid to date**',
                                },
                                { key: 'status', label: 'Status' },
                            ]}
                            filename={`Helicap_Investments.csv`}
                            target="_blank"
                        >
                            <GrDocumentCsv color="#182d4f" size={'1.4rem'} />
                        </CSVLink>
                        <Badge count={selectedCount} style={{ backgroundColor: '#41D17E' }}>
                            <FiFilter
                                onClick={() => setFilter(!openFilter)}
                                className="ml-4 cursor-pointer"
                                color="#182d4f"
                                size={'1.4rem'}
                            />
                        </Badge>
                    </div>
                    <div>
                        <div className="hidden md:block w-full investmentTable">
                            <InvestmentTable
                                loading={loading}
                                investments={
                                    applyFilters.length > 0 ? filterRows(investments, applyFilters) : investments
                                }
                            />
                        </div>
                        <div className="flex md:hidden w-full">
                            {loading && (
                                <div className="flex justify-center m-4 w-full">
                                    <Loader />
                                </div>
                            )}
                            {!loading && (
                                <InvestmentMobileCard
                                    investments={
                                        applyFilters.length > 0 ? filterRows(investments, applyFilters) : investments
                                    }
                                />
                            )}
                        </div>
                    </div>

                    {/* <InvestmentNotes /> */}
                </div>
            </div>
            <InvestmentUpdatedDocuments />
            {!loading && investments.length > 0 && (
                <div className="pt-0">
                    <CessationCard />
                </div>
            )}
        </>
    );
};

export default Investments;

export const InvestmentNotes = () => {
    return (
        <ul className="list-disc pl-4 text-[10px] font-[Lato] text-[#20222B]">
            <li>
                Information displayed under "Maturity Date", "Outstanding Principal" and "Interest Rate (p.a.)" fields
                shall be applicable to debt investments only.
            </li>
            <li>
                The "Interest rate (p.a.)" field is an indicative metric that may be subject to management and
                administrative fees, and/or other expenses. It may differ from the net interest rate you receive.
            </li>
            <li>
                The "Total Distribution/Interest paid to date" field represents the total of (1) dividend distribution
                payout for investments in Helicap’s Fund since your initial subscription, and (2) the interest paid to
                date for debt investments via Helicap Securities. Note that, as the platform was only updated on
                MMM.YYYY, the interest paid from past debt investments may not be included.
            </li>
            <li>"Interest Paid To Date" is net of Management Fees.</li>
        </ul>
    );
};
